const privacyPolicy = [
    {
        id: "overview",
        title: "1. Overview",
        content: "At AS Designs Galaxy, we sell HTML and React website templates. All payments and checkouts are securely processed by Lemon Squeezy. We only collect basic information through our contact form to respond to inquiries and provide support."
    },
    {
        id: "information",
        title: "2. Information We Collect",
        content: "We collect only the information you provide:",
        list: [
            "Name and email address (from contact form)",
            "Message content (your questions or support requests)",
            "Payment details are processed securely by Lemon Squeezy and are not stored by us"
        ]
    },
    {
        id: "usage",
        title: "3. How We Use Your Information",
        content: "We use your information only to:",
        list: [
            "Respond to your inquiries",
            "Provide support for purchased templates",
            "Improve our services and communication"
        ]
    },
    {
        id: "sharing",
        title: "4. Information Sharing",
        content: "We do not sell, trade, or share your personal information. The only third-party service involved is Lemon Squeezy for secure payment processing."
    },
    {
        id: "cookies",
        title: "5. Cookies",
        content: "Our website may use basic cookies to improve user experience and analyze website performance. You can disable cookies through your browser settings."
    },
    {
        id: "your-rights",
        title: "6. Your Rights",
        content: "You have the right to:",
        list: [
            "Request deletion of your personal data",
            "Request access to the data we hold",
            "Unsubscribe from any communications"
        ]
    },
    {
        id: "contact",
        title: "7. Contact Us",
        content: "For privacy-related questions or requests, please contact us at: support@asdesignsgalaxy.com"
    }
];

export default privacyPolicy;